import React from "react";

//UI Material
import { Button, TableCell, TableRow, Typography } from "@mui/material";

//Material Icons
import { ArrowForwardIos } from "@mui/icons-material";

export default function SupplierRow({ supplier }) {
  // ==========>Component<==========
  return (
    <TableRow>
      <TableCell align="center" sx={{ maxWidth: "200px" }}>
        <Typography variant="body2">{supplier.id}</Typography>
      </TableCell>
      <TableCell align="center" sx={{ maxWidth: "200px" }}>
        <Typography variant="body2">{supplier.name}</Typography>
      </TableCell>
      <TableCell align="center" sx={{ maxWidth: "200px" }}>
        <Typography variant="body2">{supplier.address}</Typography>
      </TableCell>
      <TableCell align="center" sx={{ maxWidth: "200px" }}>
        <Typography variant="body2">{supplier.email}</Typography>
      </TableCell>
      <TableCell align="center" sx={{ maxWidth: "200px" }}>
        <Typography variant="body2">{supplier.phoneNumber}</Typography>
      </TableCell>
      <TableCell align="center">
        <Button
          size="small"
          variant="contained"
          color="secondary"
          sx={{ color: "white" }}
          endIcon={<ArrowForwardIos />}
          onClick={() => {
            window.location.href = `/supplier?id=${supplier.id}`;
          }}
        >
          Ver proveedor
        </Button>
      </TableCell>
    </TableRow>
  );
}
